/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */
import { Heading } from 'sarsaparilla';
import type { Link } from './SharedVenuePage.types';

export interface AdditionalLinksProps {
    links?: Link[];
    headerLevel?: 1 | 2 | 3 | 4;
}

export function AdditionalLinks({ headerLevel = 2, ...props }: AdditionalLinksProps) {
    const { links } = props;

    if (!(links && links.length)) {
        return null;
    }

    const linkList = links.map(({ url, description, title }) => (
        <li key={url}>
            <a
                href={url}
                rel="noopener noreferrer"
                target="_blank"
                aria-label={`${description || title} opens in a new tab`}
            >
                {description || title}
            </a>
        </li>
    ));

    return (
        <div className="rec-aside-body rec-aside-box">
            <Heading headingLevel={headerLevel} appearance="h5">
                Additional Information
            </Heading>
            <ul className="additional-links">{linkList}</ul>
        </div>
    );
}
